module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "doc-component",
    attrs: {
      "id": "form"
    }
  }, [_c('h1', [_vm._v("Form")]), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "action": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Label")]), _vm._v(" "), _c('p', [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "default"
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    staticClass: "_focus",
    attrs: {
      "type": "text",
      "placeholder": "_focus"
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    staticClass: "_invalid",
    attrs: {
      "type": "text",
      "placeholder": "_invalid"
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    staticClass: "_valid",
    attrs: {
      "type": "text",
      "placeholder": "_valid"
    }
  })]), _vm._v(" "), _c('p', [_c('input', {
    staticClass: "_loading",
    attrs: {
      "type": "text",
      "placeholder": "_loading"
    }
  })]), _vm._v(" "), _c('p', [_c('textarea', {
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35250f9b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms.vue
// module id = 135
// module chunks = 1